import {
  type AccountInfo,
  InteractionRequiredAuthError,
  PublicClientApplication,
  type AuthenticationResult,
  type IPublicClientApplication,
} from "@azure/msal-browser";

const DEFAULT_ENTRA_TENANT_ID = "a070396c-a0f2-4283-a321-897f69dd34ce";
const DEFAULT_ENTRA_CLIENT_ID = "388a1763-defd-44d4-8f87-7b78b1820121";

const tenantId = (import.meta.env.VITE_ENTRA_TENANT_ID ?? DEFAULT_ENTRA_TENANT_ID).trim();
const clientId = (import.meta.env.VITE_ENTRA_CLIENT_ID ?? DEFAULT_ENTRA_CLIENT_ID).trim();
const authority = `https://login.microsoftonline.com/${tenantId}`;
const redirectUri = `${window.location.origin}/pricing-master`;

const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

let msalInstance: IPublicClientApplication | null = null;

export function getMsalInstance(): IPublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication({
      auth: {
        clientId,
        authority,
        redirectUri,
      },
      cache: {
        cacheLocation: "sessionStorage",
      },
    });
  }
  return msalInstance;
}

export async function consumeRedirectResult(pca: IPublicClientApplication): Promise<AuthenticationResult | null> {
  return pca.handleRedirectPromise();
}

function activeOrFirstAccount(pca: IPublicClientApplication): AccountInfo | null {
  return pca.getActiveAccount() ?? pca.getAllAccounts()[0] ?? null;
}

export async function startLogin(pca: IPublicClientApplication): Promise<void> {
  await pca.loginRedirect(loginRequest);
}

export async function acquireIdToken(pca: IPublicClientApplication): Promise<string> {
  const account = activeOrFirstAccount(pca);
  if (!account) {
    throw new Error("No signed-in account");
  }

  try {
    const tokenResult = await pca.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return tokenResult.idToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await pca.acquireTokenRedirect({
        ...loginRequest,
        account,
      });
    }
    throw error;
  }
}
